import {
  PromptObjectInput,
  PromptObjectInputSpeakAs,
  ValueOrVariableType,
  VariableReference
} from '@app/types';

export function getPromptInputHauless(varName: VariableReference): PromptObjectInput {
  return {
    argumentName: varName,
    varName: varName,
    type: ValueOrVariableType.variable,
    speakAs: PromptObjectInputSpeakAs.asIs
  };
}
